import { toast } from "react-toastify"
import { API_URL } from "../../lib/const"
import axios from "axios"

export const getSQLReportData = (page = 1) => {
  return axios
    .get(`${API_URL}/reports/sql_reports`, {
      params: { page }
    })
    .then((response) => response.data);
};

export const getSQLReportDetail = ( id ) => {
  return axios
    .get( `${API_URL}/reports/sql_reports/${id}`, )
    .then( ( response ) => { return { ...response.data, sql: atob( response.data.sql ) } } )
    .catch( ( err ) => {
      return toast.error( 'Relatório com o ID informado não encontrado' )
    } )
}

export const getSQLReportView = ( id, params ) => {
  return axios
    .get( `${API_URL}/reports/sql_reports/data?report=${id}&page=${params.page}&page_size=${params.page_size}`)
    .then( ( response ) => { return { ...response.data } } )
    .catch( ( err ) => {
      return toast.error( 'Relatório com o ID informado não encontrado' )
    } )
}

export const createSQLReportData = ( data ) => {
  return axios
    .post( `${API_URL}/reports/sql_reports`, { ...data, sql: btoa( data.sql ) } )
    .then( ( response ) => response.data )
}

export const updateSQLReportData = ( id, data ) => {
  return axios
    .patch( `${API_URL}/reports/sql_reports/${id}`, { ...data, sql: btoa( data.sql ) } )
    .then( ( response ) => response.data )
}

export const deleteSQLReportData = ( id ) => {
  return axios
    .delete( `${API_URL}/reports/sql_reports/${id}` )
    .then( ( response ) => response.data )
}
